import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { MasterService, MenuService } from "../../../master/services";
import { ApplicationAddRemoveRequest } from "../shared/ApplicationAddRemoveRequest";
import { DataService_AppSetup } from "../shared/data.service";
import { ApplicationAddSchoolComponent } from "./application-add-school/application-add-school.component";

@Component({
	selector: "caass-school-table",
	templateUrl: "./school-table.component.html",
	styleUrls: ["./school-table.component.css"],
})
export class SchoolTableComponent implements OnInit {
	constructor(
		private tableService: DataService_AppSetup,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private menuService: MenuService,
		private masterService: MasterService,
		private route: ActivatedRoute
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		// this.loadSchool();
	}

	ngOnChanges() {
		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() ApplicationID: any = "";
	@Output() TableChange: EventEmitter<any> = new EventEmitter();

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchools: any = [];
	lstSchool: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolNumber", header: "Number" },
		{ field: "SchoolName", header: "Name" },
		{ field: "ActivationBeginDTDesc", header: "Activated" },
		{ field: "ActivationEndDTDesc", header: "Expires" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		this.errorMessage = "";

		this.SelectedSchools = [];

		if (this.ApplicationID == undefined || this.ApplicationID == "") {
			this.lstSchool = [];

			return;
		}

		this.loading = true;

		var result = this.tableService.ApplicationSchoolTableSelectList(this.ApplicationID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				//Load Data Filter Lists

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		if (this.ApplicationID == "") {
			this.errorMessage = "Select an application";
			return;
		}

		this.loadSchool();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		if (this.ApplicationID == "") {
			this.errorMessage = "Select an application to add it to schools";
			return;
		}

		var ref = this.dialogService.open(ApplicationAddSchoolComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				ApplicationID: this.ApplicationID,
				SelectedSchools: this.lstSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.TableChange.emit(true);
				this.onRowUnselect(null);
				this.loadSchool();
				this.menuService.MenuRefreshAll("refresh");
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		if (this.ApplicationID == "") {
			this.errorMessage = "Select an application";
			return;
		}

		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to remove";
			return;
		}

		this.processing = true;

		//
		// Create Request
		//

		//School IDs
		var lstSchool: number[] = [];

		for (var z = 0; z < this.SelectedSchools.length; z++) {
			var next = this.SelectedSchools[z];

			lstSchool = [...lstSchool, next.SchoolID];
		}

		let parms: ApplicationAddRemoveRequest = {
			ApplicationID: this.ApplicationID,
			lstSchoolIDs: lstSchool,
		};

		//
		// Call SP
		//
		var result = this.tableService.ApplicationRemoveSchools(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					this.TableChange.emit(true);

					this.loadSchool();
					this.menuService.MenuRefreshAll("refresh");
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "school",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not remove schools",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		// this.SelectedSchool = val.data;
	}
	onRowUnselect(val) {
		// this.SelectedSchool = null;
	}
	onRowDblClick(School) {
		// this.SelectedSchool = School;
		this.onAdd();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.processing == true;
	}

	////////////////////////////////////////////
}
